import { faStar } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import "./Review_Card.css";
import React from 'react'
import { formatDate } from '../../../../utils/common';

const Review_Card = ({ product, ...props }) => {

    console.log(props?.review?.images, "productsss productsss+++++++++")

    return (
        <div className='Review_Card'>
            <div className='top_part'>
                <div className='name_div'>
                    <p>{props?.review?.User?.name}{" "}{props?.review?.User?.last_name}</p>
                </div>
            </div>

            <div className='footer_part row me-0 ms-0'>
                <div className='col-md-6'>
                    <div className='review_tab'>
                        <p className='review_text'>{props?.review?.review}</p>
                        <div className="reviews_div">
                            <div className="rating">
                                <p>{props?.review?.ratings}</p>
                            </div>
                            <div className="star_div">
                                <FontAwesomeIcon icon={faStar} className="star_icon" />
                            </div>
                        </div>
                        {/* <p>
                        <FontAwesomeIcon icon={faStar} className="star_icon" />
                        <FontAwesomeIcon icon={faStar} className="star_icon" />
                        <FontAwesomeIcon icon={faStar} className="star_icon" />
                        <FontAwesomeIcon icon={faStar} className="star_icon" />
                        <FontAwesomeIcon icon={faStar} className="star_icon" />
                    </p> */}
                        {/* {console.log(product, "productproduct")} */}
                    </div>
                </div>
                {/* 

                <div className='col-md-6 text-end'>
                    <div className='flexreviewimg'>
                        <div className='img_holder'>
                            <img
                                src={
                                    props?.review?.images?.length > 0
                                        ? process.env.REACT_APP_IMG_URL + props.review.images[0].image
                                        : product?.Product_Images?.length > 0
                                            ? process.env.REACT_APP_IMG_URL + product.Product_Images[0].image
                                            : process.env.PUBLIC_URL + "/assets/images/products/img1.png"
                                }
                                className="product_image"
                            />
                            {/* <img src={product.Product_Images ? process.env.REACT_APP_IMG_URL + product.Product_Images[0]?.image : process.env.PUBLIC_URL + '/assets/images/products/img1.png'} className='product_image' /> */}
                {/* </div> */}
                {/* </div> */}
                {/* </div> */}

                <div className='col-md-6 text-end'>
                    <div className='flexreviewimg'>

                        {props?.review?.images?.length > 0 ? (
                            // ⭐ Show ALL review images
                            props.review.images.map((img, index) => (
                                <div className='img_holder' key={index}>
                                    <img
                                        src={process.env.REACT_APP_IMG_URL + img.image}
                                        className="product_image"
                                    />
                                </div>
                            ))
                        ) : product?.Product_Images?.length > 0 ? (
                            // ⭐ Show ALL product images
                            product.Product_Images.map((img, index) => (
                                <div className='img_holder' key={index}>
                                    <img
                                        src={process.env.REACT_APP_IMG_URL + img.image}
                                        className="product_image"
                                    />
                                </div>
                            ))
                        ) : (
                            // ⭐ Fallback image
                            <div className='img_holder'>
                                <img
                                    src={process.env.PUBLIC_URL + "/assets/images/products/img1.png"}
                                    className="product_image"
                                />
                            </div>
                        )}

                    </div>
                </div>




            </div>

            <div className='date'>
                <p>{formatDate(props?.review?.createdAt)}</p>
            </div>
        </div>
    )
}

export default Review_Card
